import {createApp} from 'vue'
import {createPinia} from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import App from './App.vue'
import store from "./store";
import router from "./router";
import mixins from "@/mixins/common"; // 引入混入(全局混入)
import http from '@/http/http'
// import '@/assets/styles/element-plus.scss'
import 'element-plus/dist/index.css'
import '@/assets/styles/common.scss'
import ElementPlus from 'element-plus'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'

// Vue.config.productionTip = false

const pinia = createPinia()
const app = createApp(App);
// new Vue({
//   router,
//   render: h => h(App),
// }).$mount('#app')
//全局挂载网络请求
app.provide('$http', http)
// app.mixin(mixins)

app.use(ElementPlus)
// app.use(store)
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
//挂载路由模块
app.use(router)

app.mount('#app')

export default app
